<template>
  <div class="niconico">
    <div class="mobile">
      <script type="application/javascript" src="https://embed.nicovideo.jp/watch/sm37645332/script?w=320&h=180"></script>
      <noscript><a href="https://www.nicovideo.jp/watch/sm37645332">Pastel World 3rd Album 「アデヤカ」 XFD</a></noscript>
    </div>
    <div class="tablet">
      <iframe width="312" height="176" src="https://ext.nicovideo.jp/thumb/sm37645332" scrolling="no" style="border:solid 1px #ccc;" frameborder="0"><a href="https://www.nicovideo.jp/watch/sm37645332">【第7回博麗神社秋季例大祭】Pastel World 3rd Album 「アデヤカ」 XFD【エア第16回東方紅楼夢】</a></iframe>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Niconico',
};
</script>

<style lang="scss">
.niconico {
  margin: 20px 0;
}
.tablet {
  display: none;
}

@media screen and (min-width: 768px) {
  .mobile {
    display: none;
  }
  .tablet {
    display: inline-block;
    position: relative;
    width: 100%;
    padding-top: 176px;
    margin: 20px 0;
    iframe {
      position: absolute;
      top: 0;
      right: 0;
      width: 100%;
      height: 100%;
    }
  }
}
</style>
